import LockOpenIcon from "@mui/icons-material/LockOpen";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { useNavigate } from "react-router-dom";
import GfgModal from "@/components/GfgModal";
import { CONFIGS as MODAL_TEXT } from "@/constants/GfgModal";

/**
 * The reminder-date-customization paywall for "My Campaigns" — the standalone twin of the
 * campaign builder's `giftReminders`-style modals (same GfgModal shell + copy), for use OUTSIDE
 * the builder provider, which this page has no access to. "Upgrade" opens the Account → Plan tab,
 * same as `InternationalUpsellModal`.
 */
export default function ReminderCustomDatesUpsellModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const navigate = useNavigate();
  const cfg = MODAL_TEXT.reminderCustomDates;
  return (
    <GfgModal
      open={open}
      onClose={onClose}
      icon={<NotificationsActiveIcon sx={{ fontSize: 28, color: "var(--color-dark-dust)" }} />}
      title={cfg.title}
      description={cfg.description}
      primaryLabel={cfg.primaryLabel}
      secondaryLabel={cfg.secondaryLabel}
      primaryFirst
      primaryIcon={<LockOpenIcon />}
      onPrimary={() => navigate("/account", { state: { tab: "plan", nonce: Date.now() } })}
    />
  );
}
